<template>
  <div class="h-[100dvh] w-full bg-[hsl(var(--background))]">
    <!-- Вошедшему пользователю форму не показываем: возврат идёт молча. -->
    <LoginModal v-if="!auth.isAuthenticated" @close="onClose" @logged="onLogged" />
  </div>
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import LoginModal from "../LoginModal.vue";
import { useAuthStore } from "../../store/auth";
import { completePendingReturn } from "../../composables/useLoginReturn";
import { clearPendingReturn, peekPendingReturn, stashPendingReturn } from "../../utils/loginReturn";

// Единая форма входа: /login?return=<url>. Форма - тот же LoginModal, что
// и в основном приложении. Адрес возврата кладётся в sessionStorage сразу,
// чтобы пережить редирект на Google/Telegram; завершает возврат либо эта
// страница (пользователь уже вошёл), либо watcher в App.vue (вошёл сейчас).
// Только эта страница выставляет И очищает отложенный возврат.
const route = useRoute();
const router = useRouter();
const auth = useAuthStore();

const onLogged = () => {
  /* возврат завершит watcher в App.vue, как только auth.isAuthenticated станет true */
};

// LoginModal после успеха эмитит logged и сразу close - close не должен
// затирать отложенный возврат у уже вошедшего пользователя.
const onClose = () => {
  if (auth.isAuthenticated) {
    if (!peekPendingReturn()) router.replace("/map");
    return;
  }
  clearPendingReturn();
  router.replace("/map");
};

onMounted(async () => {
  const raw = Array.isArray(route.query.return) ? route.query.return[0] : route.query.return;
  // Без return старое значение из этой вкладки не должно пережить заход.
  if (raw) stashPendingReturn(raw);
  else clearPendingReturn();
  if (auth.isAuthenticated) {
    const result = await completePendingReturn(router);
    if (result !== "navigated") router.replace("/map");
  }
});

// Ушёл со страницы (например, "назад"), так и не войдя - отложенный возврат
// больше не актуален.
onBeforeUnmount(() => {
  if (!auth.isAuthenticated) clearPendingReturn();
});
</script>
